<template>
  <div>
    <el-row type="flex" justify="center" class="intro-tab" id="introTab">
      <el-col class="layout-container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- <el-tab-pane label="联盟跨境云系统" name="system" lazy></el-tab-pane> -->
          <el-tab-pane label="入驻流程" name="supply" lazy></el-tab-pane>
          <!-- <el-tab-pane label="服务商合作" name="cooperate" lazy></el-tab-pane> -->
        </el-tabs>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center" class="intro-container">
      <el-col class="img-container layout-container">
        <img
          :src="img"
          v-for="(img, i) in activeImg"
          :key="i"
          class="intro-img"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "supply",
      imgList: {
        system: [
          "https://img.oceanz.cn/system/intro_1.jpg",
          "https://img.oceanz.cn/system/intro_2.jpg",
          "https://img.oceanz.cn/system/intro_3.jpg",
          "https://img.oceanz.cn/system/intro_4.jpg",
        ],
        supply: [
          "https://img.oceanz.cn/supply/supply_1.png",
          "https://img.oceanz.cn/supply/supply_2.jpg",
        ],
        cooperate: [
          "https://img.oceanz.cn/cooperation/intro_1.jpg",
          "https://img.oceanz.cn/cooperation/intro_2.jpg",
          "https://img.oceanz.cn/cooperation/intro_3.jpg",
          "https://img.oceanz.cn/cooperation/intro_4.jpg",
        ],
      },
      activeImg: [],
    };
  },
  mounted() {
    this.activeImg = this.imgList[this.activeName];
  },
  methods: {
    handleClick() {
      this.activeImg = this.imgList[this.activeName];
    },
    changeTab(name) {
      this.activeName = name;
      document
        .getElementById("introTab")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
  watch: {
    activeName(name) {
      this.activeImg = this.imgList[name];
    },
  },
};
</script>

<style lang="scss">
.intro-tab {
  margin-top: 64px;
  background: #0091ea;
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item {
    font-size: 16px;
    font-weight: normal;
    color: #fff;
    height: 40px;
    line-height: 40px;
    padding: 0 24px !important;
    text-align: center;
    &.is-active {
      background: #fff;
      color: #0091ea;
    }
  }
  .el-tabs__active-bar {
    display: none;
  }
}
.intro-container {
  .img-container {
    max-width: 1200px;
    text-align: center;
    .intro-img {
      margin-top: 63px;
      width: 100%;
    }
  }
}
</style>
